import { Bonus, PersonBonus } from '@esportal/portal-service';
import React from 'react';
import { PortalContext } from '../../../../context/PortalContext';

export const useMyBonus = (personBonus: PersonBonus | null) => {
	const { portalService } = React.useContext(PortalContext);

	const [filteredBonus, setFilteredBonus] = React.useState<Bonus[]>(); // just 2
	const [carList, setCarList] = React.useState<String[]>();

	React.useMemo(() => {
		if (personBonus) {
			const carsArray: String[] = [];

			setFilteredBonus(personBonus.bonus.sort((a, b) => b.priority - a.priority));

			personBonus.bonus.forEach((bonus) => {
				if (bonus.frame) {
					const vehicle = portalService.getVehicleByFrame(bonus.frame).getValue();
					if (vehicle && !carsArray.includes(vehicle.comercialDenomination)) {
						carsArray.push(vehicle.comercialDenomination);
					}
				}
			});

			setCarList(carsArray);
		}
	}, [personBonus]);

	return { filteredBonus, carList };
};
